export default __webpack_public_path__ + "static/media/tastejs.9f3d7d07.svg";